import type { RouteDefinition } from "../route-definition.ts";

export const adminPeopleRoutes = {
  "admin.userDashboard": {
    path: "/admin/users/:userId/dashboard",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.userLeagues": {
    path: "/admin/users/:userId/leagues",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.userCoworlds": {
    path: "/admin/users/:userId/coworlds",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.userExperienceRequests": {
    path: "/admin/users/:userId/xp-requests",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.userProfile": {
    path: "/admin/users/:userId/profile",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.userPolicies": {
    path: "/admin/users/:userId/policies",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.userControls": {
    path: "/admin/users/:userId/controls",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.users": {
    path: "/admin/users",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.usersActivity": {
    path: "/admin/users/activity",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.usersRetention": {
    path: "/admin/users/retention",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.usersGrowth": {
    path: "/admin/users/growth",
    scope: "static",
    bucket: "admin",
    entry: "nav",
    disposition: "page",
  },
  "admin.player": {
    path: "/admin/players/:playerId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
  "admin.user": {
    path: "/admin/users/:userId",
    scope: "static",
    bucket: "admin",
    entry: "parent",
    disposition: "page",
  },
} as const satisfies Record<string, RouteDefinition>;
